/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WorkspaceRouteImport } from './routes/workspace'
import { Route as TestModelcardDesignRouteImport } from './routes/test-modelcard-design'
import { Route as TestCreateModelRouteImport } from './routes/test-create-model'
import { Route as DeviceRouteImport } from './routes/device'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WorkspaceIndexRouteImport } from './routes/workspace.index'
import { Route as WorkspaceTrashRouteImport } from './routes/workspace.trash'
import { Route as WorkspaceSharedRouteImport } from './routes/workspace.shared'
import { Route as WorkspaceSettingsRouteImport } from './routes/workspace.settings'
import { Route as WorkspaceRecentsRouteImport } from './routes/workspace.recents'
import { Route as WorkspaceDraftsRouteImport } from './routes/workspace.drafts'
import { Route as WorkspaceSlugRouteImport } from './routes/workspace.$slug'
import { Route as CanvasNewRouteImport } from './routes/canvas.new'
import { Route as CanvasIdRouteImport } from './routes/canvas.$id'
import { Route as AuthVerifyEmailRouteImport } from './routes/_auth.verify-email'
import { Route as AuthSignupRouteImport } from './routes/_auth.signup'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth.reset-password'
import { Route as AuthLoginRouteImport } from './routes/_auth.login'
import { Route as AuthJoinWaitlistRouteImport } from './routes/_auth.join-waitlist'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth.forgot-password'
import { Route as WorkspaceProjectUuidRouteImport } from './routes/workspace.project.$uuid'
import { Route as AuthInviteSlugRouteImport } from './routes/_auth.invite.$slug'

const WorkspaceRoute = WorkspaceRouteImport.update({
  id: '/workspace',
  path: '/workspace',
  getParentRoute: () => rootRouteImport,
} as any)
const TestModelcardDesignRoute = TestModelcardDesignRouteImport.update({
  id: '/test-modelcard-design',
  path: '/test-modelcard-design',
  getParentRoute: () => rootRouteImport,
} as any)
const TestCreateModelRoute = TestCreateModelRouteImport.update({
  id: '/test-create-model',
  path: '/test-create-model',
  getParentRoute: () => rootRouteImport,
} as any)
const DeviceRoute = DeviceRouteImport.update({
  id: '/device',
  path: '/device',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspaceIndexRoute = WorkspaceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceTrashRoute = WorkspaceTrashRouteImport.update({
  id: '/trash',
  path: '/trash',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceSharedRoute = WorkspaceSharedRouteImport.update({
  id: '/shared',
  path: '/shared',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceSettingsRoute = WorkspaceSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceRecentsRoute = WorkspaceRecentsRouteImport.update({
  id: '/recents',
  path: '/recents',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceDraftsRoute = WorkspaceDraftsRouteImport.update({
  id: '/drafts',
  path: '/drafts',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceSlugRoute = WorkspaceSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => WorkspaceRoute,
} as any)
const CanvasNewRoute = CanvasNewRouteImport.update({
  id: '/canvas/new',
  path: '/canvas/new',
  getParentRoute: () => rootRouteImport,
} as any)
const CanvasIdRoute = CanvasIdRouteImport.update({
  id: '/canvas/$id',
  path: '/canvas/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthVerifyEmailRoute = AuthVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthJoinWaitlistRoute = AuthJoinWaitlistRouteImport.update({
  id: '/join-waitlist',
  path: '/join-waitlist',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const WorkspaceProjectUuidRoute = WorkspaceProjectUuidRouteImport.update({
  id: '/project/$uuid',
  path: '/project/$uuid',
  getParentRoute: () => WorkspaceRoute,
} as any)
const AuthInviteSlugRoute = AuthInviteSlugRouteImport.update({
  id: '/invite/$slug',
  path: '/invite/$slug',
  getParentRoute: () => AuthRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/device': typeof DeviceRoute
  '/test-create-model': typeof TestCreateModelRoute
  '/test-modelcard-design': typeof TestModelcardDesignRoute
  '/workspace': typeof WorkspaceRouteWithChildren
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/join-waitlist': typeof AuthJoinWaitlistRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/signup': typeof AuthSignupRoute
  '/verify-email': typeof AuthVerifyEmailRoute
  '/canvas/$id': typeof CanvasIdRoute
  '/canvas/new': typeof CanvasNewRoute
  '/workspace/$slug': typeof WorkspaceSlugRoute
  '/workspace/drafts': typeof WorkspaceDraftsRoute
  '/workspace/recents': typeof WorkspaceRecentsRoute
  '/workspace/settings': typeof WorkspaceSettingsRoute
  '/workspace/shared': typeof WorkspaceSharedRoute
  '/workspace/trash': typeof WorkspaceTrashRoute
  '/workspace/': typeof WorkspaceIndexRoute
  '/invite/$slug': typeof AuthInviteSlugRoute
  '/workspace/project/$uuid': typeof WorkspaceProjectUuidRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/device': typeof DeviceRoute
  '/test-create-model': typeof TestCreateModelRoute
  '/test-modelcard-design': typeof TestModelcardDesignRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/join-waitlist': typeof AuthJoinWaitlistRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/signup': typeof AuthSignupRoute
  '/verify-email': typeof AuthVerifyEmailRoute
  '/canvas/$id': typeof CanvasIdRoute
  '/canvas/new': typeof CanvasNewRoute
  '/workspace/$slug': typeof WorkspaceSlugRoute
  '/workspace/drafts': typeof WorkspaceDraftsRoute
  '/workspace/recents': typeof WorkspaceRecentsRoute
  '/workspace/settings': typeof WorkspaceSettingsRoute
  '/workspace/shared': typeof WorkspaceSharedRoute
  '/workspace/trash': typeof WorkspaceTrashRoute
  '/workspace': typeof WorkspaceIndexRoute
  '/invite/$slug': typeof AuthInviteSlugRoute
  '/workspace/project/$uuid': typeof WorkspaceProjectUuidRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/device': typeof DeviceRoute
  '/test-create-model': typeof TestCreateModelRoute
  '/test-modelcard-design': typeof TestModelcardDesignRoute
  '/workspace': typeof WorkspaceRouteWithChildren
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/join-waitlist': typeof AuthJoinWaitlistRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_auth/signup': typeof AuthSignupRoute
  '/_auth/verify-email': typeof AuthVerifyEmailRoute
  '/canvas/$id': typeof CanvasIdRoute
  '/canvas/new': typeof CanvasNewRoute
  '/workspace/$slug': typeof WorkspaceSlugRoute
  '/workspace/drafts': typeof WorkspaceDraftsRoute
  '/workspace/recents': typeof WorkspaceRecentsRoute
  '/workspace/settings': typeof WorkspaceSettingsRoute
  '/workspace/shared': typeof WorkspaceSharedRoute
  '/workspace/trash': typeof WorkspaceTrashRoute
  '/workspace/': typeof WorkspaceIndexRoute
  '/_auth/invite/$slug': typeof AuthInviteSlugRoute
  '/workspace/project/$uuid': typeof WorkspaceProjectUuidRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/device'
    | '/test-create-model'
    | '/test-modelcard-design'
    | '/workspace'
    | '/forgot-password'
    | '/join-waitlist'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/verify-email'
    | '/canvas/$id'
    | '/canvas/new'
    | '/workspace/$slug'
    | '/workspace/drafts'
    | '/workspace/recents'
    | '/workspace/settings'
    | '/workspace/shared'
    | '/workspace/trash'
    | '/workspace/'
    | '/invite/$slug'
    | '/workspace/project/$uuid'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/device'
    | '/test-create-model'
    | '/test-modelcard-design'
    | '/forgot-password'
    | '/join-waitlist'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/verify-email'
    | '/canvas/$id'
    | '/canvas/new'
    | '/workspace/$slug'
    | '/workspace/drafts'
    | '/workspace/recents'
    | '/workspace/settings'
    | '/workspace/shared'
    | '/workspace/trash'
    | '/workspace'
    | '/invite/$slug'
    | '/workspace/project/$uuid'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/device'
    | '/test-create-model'
    | '/test-modelcard-design'
    | '/workspace'
    | '/_auth/forgot-password'
    | '/_auth/join-waitlist'
    | '/_auth/login'
    | '/_auth/reset-password'
    | '/_auth/signup'
    | '/_auth/verify-email'
    | '/canvas/$id'
    | '/canvas/new'
    | '/workspace/$slug'
    | '/workspace/drafts'
    | '/workspace/recents'
    | '/workspace/settings'
    | '/workspace/shared'
    | '/workspace/trash'
    | '/workspace/'
    | '/_auth/invite/$slug'
    | '/workspace/project/$uuid'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  DeviceRoute: typeof DeviceRoute
  TestCreateModelRoute: typeof TestCreateModelRoute
  TestModelcardDesignRoute: typeof TestModelcardDesignRoute
  WorkspaceRoute: typeof WorkspaceRouteWithChildren
  CanvasIdRoute: typeof CanvasIdRoute
  CanvasNewRoute: typeof CanvasNewRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/workspace': {
      id: '/workspace'
      path: '/workspace'
      fullPath: '/workspace'
      preLoaderRoute: typeof WorkspaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/test-modelcard-design': {
      id: '/test-modelcard-design'
      path: '/test-modelcard-design'
      fullPath: '/test-modelcard-design'
      preLoaderRoute: typeof TestModelcardDesignRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/test-create-model': {
      id: '/test-create-model'
      path: '/test-create-model'
      fullPath: '/test-create-model'
      preLoaderRoute: typeof TestCreateModelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/device': {
      id: '/device'
      path: '/device'
      fullPath: '/device'
      preLoaderRoute: typeof DeviceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/': {
      id: '/workspace/'
      path: '/'
      fullPath: '/workspace/'
      preLoaderRoute: typeof WorkspaceIndexRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/workspace/trash': {
      id: '/workspace/trash'
      path: '/trash'
      fullPath: '/workspace/trash'
      preLoaderRoute: typeof WorkspaceTrashRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/workspace/shared': {
      id: '/workspace/shared'
      path: '/shared'
      fullPath: '/workspace/shared'
      preLoaderRoute: typeof WorkspaceSharedRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/workspace/settings': {
      id: '/workspace/settings'
      path: '/settings'
      fullPath: '/workspace/settings'
      preLoaderRoute: typeof WorkspaceSettingsRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/workspace/recents': {
      id: '/workspace/recents'
      path: '/recents'
      fullPath: '/workspace/recents'
      preLoaderRoute: typeof WorkspaceRecentsRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/workspace/drafts': {
      id: '/workspace/drafts'
      path: '/drafts'
      fullPath: '/workspace/drafts'
      preLoaderRoute: typeof WorkspaceDraftsRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/workspace/$slug': {
      id: '/workspace/$slug'
      path: '/$slug'
      fullPath: '/workspace/$slug'
      preLoaderRoute: typeof WorkspaceSlugRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/canvas/new': {
      id: '/canvas/new'
      path: '/canvas/new'
      fullPath: '/canvas/new'
      preLoaderRoute: typeof CanvasNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/canvas/$id': {
      id: '/canvas/$id'
      path: '/canvas/$id'
      fullPath: '/canvas/$id'
      preLoaderRoute: typeof CanvasIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/verify-email': {
      id: '/_auth/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof AuthVerifyEmailRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/signup': {
      id: '/_auth/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/join-waitlist': {
      id: '/_auth/join-waitlist'
      path: '/join-waitlist'
      fullPath: '/join-waitlist'
      preLoaderRoute: typeof AuthJoinWaitlistRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/workspace/project/$uuid': {
      id: '/workspace/project/$uuid'
      path: '/project/$uuid'
      fullPath: '/workspace/project/$uuid'
      preLoaderRoute: typeof WorkspaceProjectUuidRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/_auth/invite/$slug': {
      id: '/_auth/invite/$slug'
      path: '/invite/$slug'
      fullPath: '/invite/$slug'
      preLoaderRoute: typeof AuthInviteSlugRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthJoinWaitlistRoute: typeof AuthJoinWaitlistRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignupRoute: typeof AuthSignupRoute
  AuthVerifyEmailRoute: typeof AuthVerifyEmailRoute
  AuthInviteSlugRoute: typeof AuthInviteSlugRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthJoinWaitlistRoute: AuthJoinWaitlistRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignupRoute: AuthSignupRoute,
  AuthVerifyEmailRoute: AuthVerifyEmailRoute,
  AuthInviteSlugRoute: AuthInviteSlugRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface WorkspaceRouteChildren {
  WorkspaceSlugRoute: typeof WorkspaceSlugRoute
  WorkspaceDraftsRoute: typeof WorkspaceDraftsRoute
  WorkspaceRecentsRoute: typeof WorkspaceRecentsRoute
  WorkspaceSettingsRoute: typeof WorkspaceSettingsRoute
  WorkspaceSharedRoute: typeof WorkspaceSharedRoute
  WorkspaceTrashRoute: typeof WorkspaceTrashRoute
  WorkspaceIndexRoute: typeof WorkspaceIndexRoute
  WorkspaceProjectUuidRoute: typeof WorkspaceProjectUuidRoute
}

const WorkspaceRouteChildren: WorkspaceRouteChildren = {
  WorkspaceSlugRoute: WorkspaceSlugRoute,
  WorkspaceDraftsRoute: WorkspaceDraftsRoute,
  WorkspaceRecentsRoute: WorkspaceRecentsRoute,
  WorkspaceSettingsRoute: WorkspaceSettingsRoute,
  WorkspaceSharedRoute: WorkspaceSharedRoute,
  WorkspaceTrashRoute: WorkspaceTrashRoute,
  WorkspaceIndexRoute: WorkspaceIndexRoute,
  WorkspaceProjectUuidRoute: WorkspaceProjectUuidRoute,
}

const WorkspaceRouteWithChildren = WorkspaceRoute._addFileChildren(
  WorkspaceRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  DeviceRoute: DeviceRoute,
  TestCreateModelRoute: TestCreateModelRoute,
  TestModelcardDesignRoute: TestModelcardDesignRoute,
  WorkspaceRoute: WorkspaceRouteWithChildren,
  CanvasIdRoute: CanvasIdRoute,
  CanvasNewRoute: CanvasNewRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
